import { render, staticRenderFns } from "./productVibration.vue?vue&type=template&id=2c4be46b&scoped=true&"
import script from "./productVibration.vue?vue&type=script&lang=js&"
export * from "./productVibration.vue?vue&type=script&lang=js&"
import style0 from "./productVibration.vue?vue&type=style&index=0&id=2c4be46b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4be46b",
  null
  
)

export default component.exports